import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import PublicLayout from './pages/PublicLayout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ActivityPage from './pages/ActivityPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import ContactsPage from './pages/ContactsPage';
import FaqPage from './pages/FaqPage';
import JoinPage from './pages/JoinPage';
import DocumentsPage from './pages/DocumentsPage';

import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminActivitiesPage from './pages/admin/AdminActivitiesPage';
import AdminRegionsPage from './pages/admin/AdminRegionsPage';
import AdminNewsPage from './pages/admin/AdminNewsPage';
import AdminSliderPage from './pages/admin/AdminSliderPage';
import AdminContactsPage from './pages/admin/AdminContactsPage';
import AdminSocialLinksPage from './pages/admin/AdminSocialLinksPage';
import AdminFeedbackPage from './pages/admin/AdminFeedbackPage';
import AdminWorkersPage from './pages/admin/AdminWorkersPage';
import AdminFaqPage from './pages/admin/AdminFaqPage';
import AdminJoinPage from './pages/admin/AdminJoinPage';
import AdminDocumentsPage from './pages/admin/AdminDocumentsPage';
import AdminCategoriesPage from './pages/admin/AdminCategoriesPage';

import './index.css';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin } = useAuth();
  return isAdmin ? <>{children}</> : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Публичные страницы — все через PublicLayout */}
        <Route element={<PublicLayout />}>
          <Route path="/"           element={<HomePage />} />
          <Route path="/activities" element={<ActivityPage />} />
          <Route path="/news"       element={<NewsPage />} />
          <Route path="/news/:id"   element={<NewsDetailPage />} />
          <Route path="/contacts"   element={<ContactsPage />} />
          <Route path="/faq"        element={<FaqPage />} />
          <Route path="/join"       element={<JoinPage />} />
          <Route path="/documents"  element={<DocumentsPage />} />
        </Route>

        {/* Логин — без лейаута */}
        <Route path="/login" element={<LoginPage />} />

        {/* Админ-панель */}
        <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="activities" element={<AdminActivitiesPage />} />
          <Route path="regions"    element={<AdminRegionsPage />} />
          <Route path="news"       element={<AdminNewsPage />} />
          <Route path="slider"     element={<AdminSliderPage />} />
          <Route path="contacts"   element={<AdminContactsPage />} />
          <Route path="social-links" element={<AdminSocialLinksPage />} />
          <Route path="feedback"   element={<AdminFeedbackPage />} />
          <Route path="workers"    element={<AdminWorkersPage />} />
          <Route path="faq"        element={<AdminFaqPage />} />
          <Route path="join"       element={<AdminJoinPage />} />
          <Route path="documents"  element={<AdminDocumentsPage />} />
          <Route path="categories" element={<AdminCategoriesPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
